export default function AdminDashboardPage(props: any): JSX.Element {
  return (
    <></>
  );
}
